import { DesktopMainFrame } from "@/desktop/components/DesktopMainFrame";

export function DesktopContainerLocationPage() {
    return <DesktopMainFrame>
        asdsad
    </DesktopMainFrame>;
}